import a from "./index241.js";
import { createElementBlock as s, openBlock as t, createElementVNode as o, createCommentVNode as d, normalizeClass as l, renderSlot as i, toDisplayString as c } from "vue";
/* empty css         */
import u from "./index231.js";
const m = ["data-component"], f = { class: "relative flex items-center vertical-padding" }, p = ["id", "name", "checked", "disabled"], b = ["for"], h = {
  key: 0,
  class: "text-color-alert-negative-100",
  "data-test-id": "error"
};
function g(e, r, v, k, w, y) {
  return t(), s("div", {
    "data-component": e.$options.name
  }, [
    o("div", f, [
      o("input", {
        id: e.finalId,
        type: "checkbox",
        class: "absolute inset-0 w-full h-full cursor-pointer disabled:cursor-not-allowed input",
        autocomplete: "off",
        name: e.name,
        checked: e.checked,
        disabled: e.isDisabled,
        onChange: r[0] || (r[0] = (...n) => e.onChange && e.onChange(...n))
      }, null, 40, p),
      o("div", {
        class: l(["flex items-center self-start justify-center w-24 h-24 mr-16 border border-solid border-color-neutral-grey-20 checkbox rounded-normal shrink-0", {
          "!border-color-alert-negative-100": (e.showError || e.errorMsg) && !e.isDisabled,
          "!border-color-neutral-grey-10": e.isDisabled
        }])
      }, r[1] || (r[1] = [
        o("div", { class: "w-16 h-16 dot rounded-[4px]" }, null, -1)
      ]), 2),
      o("label", {
        class: l(["text-text-l", {
          "text-color-alert-negative-100": (e.showError || e.errorMsg) && !e.isDisabled,
          "text-color-neutral-grey-20 cursor-not-allowed": e.isDisabled
        }]),
        for: e.finalId
      }, [
        i(e.$slots, "default", {}, void 0, !0)
      ], 10, b)
    ]),
    e.errorMsg ? (t(), s("div", h, c(e.errorMsg), 1)) : d("", !0)
  ], 8, m);
}
const M = /* @__PURE__ */ u(a, [["render", g], ["__scopeId", "data-v-31af331c"]]);
export {
  M as default
};
